import React from 'react';

const ProvisioningPage = () => <div>Loading...</div>;

export default ProvisioningPage;
